import { DualPalette } from "../types";

export const background: DualPalette = {
  default: { light: "#f1f5f9", dark: "#3b445a" },
  paper:   { light: "#ffffff", dark: "#4f5972ff" },
};
